"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Headline = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
exports.Headline = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, className = _a.className, el = _a.el, inline = _a.inline, italic = _a.italic, subdued = _a.subdued, _c = _a.size, size = _c === void 0 ? 'medium' : _c, props = __rest(_a, ["children", "className", "el", "inline", "italic", "subdued", "size"]);
    var TextClasses = classnames_1.default('Headline', className, (_b = {},
        _b["Headline--" + size] = size,
        _b['d-i'] = inline,
        _b['fs-italic'] = italic,
        _b['fs-normal'] = !italic && italic != null,
        _b['c-neutral-90'] = subdued,
        _b));
    var newEl = function () {
        if (!el) {
            if (size === 'xlarge')
                return 'p';
            if (size === 'large')
                return 'h1';
            if (size === 'medium')
                return 'h2';
            if (size === 'small')
                return 'h3';
        }
        return el;
    };
    var HeadlineElement = newEl();
    return (react_1.default.createElement(HeadlineElement, __assign({ ref: ref, className: TextClasses }, props), children));
});
//# sourceMappingURL=Headline.js.map